export class VacationType {
  id: number;
  name: string;
  isVacation: boolean;
}
